import React from 'react'
import PropTypes from 'prop-types'
import './banner1.css'

const Banner1 = ({ heading1, content1, action1, actionHref = '/rules', rootClassName = '' }) => (
  <header className={`banner1-container1 thq-section-padding ${rootClassName}`}>
    <div className="banner1-thq-max-width-elm thq-section-max-width">
      <div className="banner1-container2">
        <h1 className="banner1-thq-title-elm thq-heading-2">
          {heading1 || 'Welcome to NuggetCraft SMP'}
        </h1>
        <p className="banner1-text1 thq-body-large">
          {content1 || 'Explore the rules, latest news, and more!'}
        </p>
      </div>
      <a className="thq-button-filled" href={actionHref}>
        {action1 || 'View Rules'}
      </a>
    </div>
  </header>
)

Banner1.propTypes = {
  heading1: PropTypes.node,
  content1: PropTypes.node,
  action1: PropTypes.node,
  actionHref: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Banner1
